import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type ViewTransitionDirection = 'up' | 'down' | 'left' | 'right' | 'none';

export interface ViewTransitionState {
  direction: ViewTransitionDirection;
  sequence: number;
}

@Injectable({
  providedIn: 'root'
})
export class ViewTransitionDirectionService {
  private _sequence = 0;
  private readonly _stateSubject = new BehaviorSubject<ViewTransitionState>({
    direction: 'none',
    sequence: 0
  });

  public get state$(): Observable<ViewTransitionState> {
    return this._stateSubject.asObservable();
  }

  public setDirection(direction: ViewTransitionDirection): void {
    this._sequence += 1;
    this._stateSubject.next({
      direction,
      sequence: this._sequence
    });
  }
}
